<template>
    <div class="btn-group-toggle" data-toggle="buttons">
        <slot name="extra"></slot>

        <template v-for="(option, index) in options">
            <br v-if="option.lineBreak" />
            <label
                v-else
                class="btn position-relative"
                :class="[
                    {
                        active: isSelected(option.value),
                        disabled: option.disabled || disabled,
                    },
                    buttonClasses,
                ]"
                :key="index"
            >
                <input
                    v-model="modelValue"
                    :value="option.value"
                    :name="name"
                    :disabled="option.disabled || disabled"
                    :type="nativeType"
                    autocomplete="off"
                />
                {{ option.label }}

                <slot name="item-extra" v-bind:option="option" />
            </label>
        </template>
    </div>
</template>
<script>
export default {
    name: "grouped-options",
    props: {
        value: [Array, Number, String],
        nativeType: {
            type: String,
            description: "Input type (checkbox|radio)",
            default: "radio",
        },
        options: {
            type: Array,
            description: 'Options. Should be an array of objects {value: "", label: ""}',
            default: () => [],
        },
        name: {
            type: String,
            description: "Input name",
        },
        buttonClasses: {
            type: [String, Object],
            description: "Inner button css classes",
        },
        disabled: {
          type: Boolean,
          default: false
        }
    },
    computed: {
        modelValue: {
            get() {
                if ("checkbox" == this.nativeType) return this.value || [];
                else return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    methods: {
        isSelected(value) {
            if ("checkbox" === this.nativeType)
                return 0 <= this.modelValue.indexOf(value);
            else return this.modelValue === value;
        },
    },
};
</script>

<style lang="scss">
.btn-group-toggle {
    .disabled {
        cursor: not-allowed !important;
    }

    .btn {
        min-height: 20px;
    }
}
</style>
